import { useState } from 'react';
import { Center, Container, Input } from '../../../components/Form';
import './style.css';
import PanelLayout from '../../panelComponents/PanelLayout/PanelLayout';
import { Button } from '../../../components/Button';
import { useDispatch } from 'react-redux';
import { toastError, toastSuccess } from '../../../BTUI/BtToast';
import { addExecutive } from '../../../store/userSlice';
import { useNavigate } from 'react-router-dom';

const AddExecutive = () => {
    const [payload, setPayload] = useState({})
    const [error, setError] = useState({});
    const dispatch = useDispatch()
    const navigate = useNavigate()


    const handleChange = (name, value) => {
        setPayload({
            ...payload,
            [name]: value
        })
        console.log(name, value)
        setError({
            ...error,
            [name]: null
        })
    }

    const handleSubmit = () => {
        dispatch(addExecutive(payload))
        .then((res) => {
            console.log("Executive ",res)
            toastSuccess(res?.data?.message)
            setPayload("")
            navigate
            ('/executive/list')
        })
        .catch((err) => {
            console.error(err)
            toastError(err?.data?.message)
        });
    }
    return <PanelLayout>
                <h1 style={{textAlign: 'center', marginBottom: '1em'}}>Add New Executive</h1>
            <Container width={`30em`}>
                {/* <div className=""> */}
                    {/* <FormGroup>
                        <FormField> */}
                            <Input 
                                label="Name"
                                name="name"
                                value={payload?.name}
                                error={error?.name}
                                handleChange={handleChange}
                            />
                            <br/>
                            <Input 
                                label="Email"
                                name="email"
                                value={payload?.email}
                                error={error?.email}
                                handleChange={handleChange}
                            />
                        {/* </FormField>
                        <FormField> */}
                        <br/>
                            <Input 
                                label="Password"
                                name="password"
                                password
                                value={payload?.password}
                                error={error?.password}
                                handleChange={handleChange}
                            />
                        {/* </FormField>
                    </FormGroup> */}
                    <br/>
                {/* </div> */}
                <Center>
                    <Button title="Add Executive" onClick={handleSubmit} />
                </Center>
            </Container>
            
    </PanelLayout>
}

export default AddExecutive